import apiClient from './client';

export interface Vendor {
  id: number;
  name: string;
  contact?: string;
  phone?: string;
  email?: string;
  address?: string;
  website?: string;
  notes?: string;
  materials_count?: number;
  materialsCount?: number;
  on_time_delivery?: number;
  onTimeDelivery?: number;
  created_at?: string;
  updated_at?: string;
}

export const getVendors = async (): Promise<Vendor[]> => {
  const response = await apiClient.get('/vendors');
  return response.data.data;
};

export const getVendor = async (id: number): Promise<Vendor> => {
  const response = await apiClient.get(`/vendors/${id}`);
  return response.data.data;
};

export const createVendor = async (data: {
  name: string;
  contact?: string;
  phone?: string;
  email?: string;
  address?: string;
  website?: string;
  notes?: string;
}): Promise<Vendor> => {
  const response = await apiClient.post('/vendors', data);
  return response.data.data;
};

export const updateVendor = async (
  id: number,
  data: {
    name?: string;
    contact?: string;
    phone?: string;
    email?: string;
    address?: string;
    website?: string;
    notes?: string;
  }
): Promise<void> => {
  await apiClient.put(`/vendors/${id}`, data);
};

export const deleteVendor = async (id: number): Promise<void> => {
  await apiClient.delete(`/vendors/${id}`);
};

// ── Vendor payables (CR #84) ────────────────────────────────────────────────

export interface VendorExpense {
  id: number;
  job_id: number;
  vendor: string | null;
  vendor_id: number | null;
  category: string;
  expense_date: string | null;
  total: number;
  description: string | null;
  paid: boolean;
  due_date: string | null;
  invoice_number: string | null;
  overdue: boolean;
  created_at: string;
  job_title: string | null;
  job_number: string | null;
  client_id: number | null;
}

export interface VendorExpenseSummary {
  total: number;
  count: number;
  paid_total: number;
  unpaid_total: number;
  unpaid_count: number;
  overdue_count: number;
}

export const getVendorExpenses = async (
  id: number,
): Promise<{ vendor: { id: number; name: string }; expenses: VendorExpense[]; summary: VendorExpenseSummary }> => {
  const response = await apiClient.get(`/vendors/${id}/expenses`);
  return response.data.data;
};
